/**
 * tdesign v1.6.6
 * (c) 2023 tdesign
 * @license MIT
 */

var datePickerProps = {
  allowInput: Boolean,
  clearable: Boolean,
  defaultTime: {
    type: String,
    "default": "00:00:00"
  },
  disableDate: {
    type: [Object, Array, Function]
  },
  disabled: Boolean,
  enableTimePicker: Boolean,
  firstDayOfWeek: {
    type: Number,
    validator: function validator(val) {
      if (!val) return true;
      return [1, 2, 3, 4, 5, 6, 7].includes(val);
    }
  },
  format: {
    type: String,
    "default": void 0
  },
  inputProps: {
    type: Object
  },
  mode: {
    type: String,
    "default": "date",
    validator: function validator(val) {
      if (!val) return true;
      return ["year", "quarter", "month", "week", "date"].includes(val);
    }
  },
  placeholder: {
    type: [String, Array],
    "default": void 0
  },
  popupProps: {
    type: Object
  },
  prefixIcon: {
    type: Function
  },
  presets: {
    type: Object
  },
  presetsPlacement: {
    type: String,
    "default": "bottom",
    validator: function validator(val) {
      if (!val) return true;
      return ["left", "top", "right", "bottom"].includes(val);
    }
  },
  size: {
    type: String,
    "default": "medium",
    validator: function validator(val) {
      if (!val) return true;
      return ["small", "medium", "large"].includes(val);
    }
  },
  status: {
    type: String,
    "default": "default",
    validator: function validator(val) {
      if (!val) return true;
      return ["default", "success", "warning", "error"].includes(val);
    }
  },
  suffixIcon: {
    type: Function
  },
  timePickerProps: {
    type: Object
  },
  tips: {
    type: [String, Function]
  },
  value: {
    type: [String, Number, Array, Date],
    "default": ""
  },
  defaultValue: {
    type: [String, Number, Array, Date],
    "default": ""
  },
  valueType: {
    type: String,
    "default": ""
  },
  onBlur: Function,
  onChange: Function,
  onConfirm: Function,
  onFocus: Function,
  onPick: Function,
  onPresetClick: Function
};

export { datePickerProps as default };
//# sourceMappingURL=props.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/tdesign-vue/es/date-picker/props.js
// module id = null
// module chunks = 